import { Map as ImmutableMap } from 'immutable';
import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { EMAIL_ADDRESS_FETCH } from '../constants/asyncActionTypes';
import { fetchEmailAddressRecords as fetchEmailAddressRecordsClient } from '../clients/fetchEmailAddressRecords';
export const fetchEmailAddressRecords = createAsyncAction({
  requestFn: fetchEmailAddressRecordsClient,
  actionTypes: EMAIL_ADDRESS_FETCH,
  toRecordFn: response => ImmutableMap(response)
});